import { UPDATE_ENVIRONMENT } from '../actions/actions';

let  originalEnvironment = undefined;

// window.parent.ShopifyBotData = {
//   "_id": "666aa4df08a909b943e75f0b",
//   "_user": "6620a8b9b9a7e19181b90729",
//   "name": "Bot 1",
//   "platforms": [
//     "website",
//     "landing",
//     "mobile-app",
//     "embedded"
//   ],
//   "design": {
//     "position": "bottom-right",
//     "mobilePosition": "bottom-right",
//     "themeColor": "#0085E6",
//     "backgroundColor": "#FFFFFF",
//     "textColor": "#ffffff",
//     "welcomeMessage": "May I help you?",
//     "height": 500,
//     "width": 360,
//     "avatar": "https://cdn.botpenguin.com/assets/avatars/profile-28.svg",
//     "fontFamilyLink": "",
//     "links": [],
//     "design": "design_1",
//     "headerText": "This is your heading text, you can edit it any time.",
//     "descriptionText": "This is your description text, you can edit it any time.",
//     "backgroundType": "color",
//     "background": "#118cfc",
//     "gradientColor": [
//       "#4880EC",
//       "#019CAD"
//     ],
//     "view": "center",
//     "hideInfo": false,
//     "backgroundColorSecondary": "#fff",
//     "skipCount": 3,
//     "_id": "666aa4df08a909b943e75f0c"
//   },
//   "status": "ACTIVE",
//   "description": "",
//   "flows": [
//     {
//       "id": "7d578ceb-0540-4394-82a1-028ab724de66",
//       "name": "My First Flow",
//       "default": false,
//       "status": "ACTIVE",
//       "questions": [
//         {
//           "id": "dbf43825-1b6e-4bf9-a466-ab7774299f37",
//           "name": "AI",
//           "status": "ACTIVE",
//           "type": "AI",
//           "label": "Welcome to ShopifyBot. I am here to help you.",
//           "icon": "",
//           "source": "",
//           "example": "",
//           "required": false,
//           "skip": false,
//           "skipIfAnswered": false,
//           "sendNotifications": true,
//           "back": false,
//           "options": [],
//           "message": {
//             "error": "",
//             "success": "",
//             "unavailable": "",
//             "configureDomains": {
//               "domainAction": "exclude",
//               "selectedDomainsList": [],
//               "domainErrorMessage": "This domain is not Acceptable"
//             }
//           },
//           "links": [],
//           "minRange": 0,
//           "maxRange": 10,
//           "rangePrefix": "From",
//           "showTime": false,
//           "delay": 1,
//           "rangeSuffix": "To",
//           "rangeStep": 1,
//           "includeInLeads": false,
//           "queriesToHandle": "10",
//           "validation": false,
//           "next": {
//             "type": "question",
//             "target": ""
//           },
//           "_id": "5f33e8a0dc169947560501ab"
//         }
//       ],
//       "description": "",
//       "_id": "666aa4df08a909b943e75f0d",
//       "createdAt": "2024-06-20T12:17:55.953Z",
//       "updatedAt": "2024-06-20T12:17:55.953Z"
//     }
//   ],
//   "configuration": {
//     "conversationalBot": {
//       "url": [],
//       "scrappingStatus": "PENDING",
//       "lastDocumentId": 0,
//       "messageCount": 0
//     },
//     "generalSettings": {
//       "status": true,
//       "timezone": {
//         "offset": 5.5,
//         "text": "India Standard Time"
//       },
//       "sendAllResponses": true,
//       "sendIncompleteResponses": false,
//       "saveResponses": true,
//       "language": "en",
//       "brandName": "EcommerceBot",
//       "whiteLabel": false,
//       "showIpInConversations": true,
//       "waitingMessage": "Usual reply time: 2 to 3 Minutes",
//       "unavailabilityMessage": "The agent is currently unavailable. Please try again later. We apologize for any inconvenience caused. Thank you for your patience.",
//       "visibility": {
//         "country": true,
//         "location": true,
//         "lastSeen": true,
//         "device": true,
//         "browser": true,
//         "ip": true,
//         "operatingSystem": true
//       },
//       "userChatRetention": "session"
//     },
//     "alertSettings": {
//       "email": {
//         "status": true,
//         "subject": "New lead from your ShopifyBot Bot",
//         "emails": [
//           "gimoma3256@gmail.com"
//         ]
//       },
//       "sendWeeklyReport": false,
//       "leadRevisitAlert": false
//     },
//     "triggerSettings": {
//       "autoTrigger": 1,
//       "autoTriggerOnDesktop": 5,
//       "autoTriggerOnMobile": 5,
//       "openWhenUserClose": "always",
//       "autoTriggerWhenUserClose": 20,
//       "disableAutoTrigger": false
//     },
//     "userAccessSettings": {
//       "showOn": "all",
//       "blockedIps": [],
//       "hideOnUrls": [],
//       "showOnUrls": [],
//       "hideInCountries": [],
//       "showInCountries": [],
//       "availabilityType": "none",
//       "availability": [
//         {
//           "day": "sunday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af354f"
//         },
//         {
//           "day": "monday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af3550"
//         },
//         {
//           "day": "tuesday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af3551"
//         },
//         {
//           "day": "wednesday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af3552"
//         },
//         {
//           "day": "thursday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af3553"
//         },
//         {
//           "day": "friday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af3554"
//         },
//         {
//           "day": "saturday",
//           "from": 1,
//           "to": 23,
//           "_id": "66741df370aa9bb1d8af3555"
//         }
//       ],
//       "contactLink": "https://example.com/contact-us",
//       "whitelistDomains": [],
//       "flowUrlMapping": []
//     },
//     "seoSettings": {
//       "googleAnalyticsId": "",
//       "facebookPixelId": "",
//       "metaTitle": "",
//       "metaImage": "",
//       "favicon": "",
//       "metaDescription": "",
//       "metaKeywords": ""
//     },
//     "chatMenu": {
//       "toWhatsapp": true,
//       "toChatBot": true,
//       "toLiveChat": true,
//       "refreshChat": true
//     },
//     "_id": "666aa4df08a909b943e75f10"
//   },
//   "lastIntractedAt": "2024-06-20T12:26:54.131Z",
//   "installVerificationStatus": "PENDING",
//   "whitelabel": {
//     "active": false,
//     "byAgency": false
//   },
//   "counts": {
//     "subscribers": 17,
//     "messages": 36,
//     "subscribersCurrentCycle": 17,
//     "messagesCurrentCycle": 36
//   },
//   "ai": {
//     "consumedFreeUsage": 29,
//     "allowedFreeUsage": 100,
//     "elasticSearchIndex": "bot_666aa4df08a909b943e75f0b",
//     "contentLanguage": [],
//     "chatGPT": {
//       "model": "gpt-3.5-turbo",
//       "knowledgeMix": [],
//       "key": false
//     },
//     "sanitize": {
//       "formatting": "PARAGRAPH",
//       "language": "ENGLISH"
//     },
//     "messages": {
//       "start": "Hey, I am conversational chatbot trained using Generative AI. How can I help you today?",
//       "noAnswer": "",
//       "profanity": "I am not quite used to such language. I request you to be professional in our communication."
//     },
//     "config": {
//       "maxUserWords": 100,
//       "messageLimit": {
//         "count": 10,
//         "seconds": 60
//       },
//       "showReferenceLink": false
//     }
//   },
//   "installations": [
//     {
//       "siteUrl": "https://www.w3schools.com",
//       "timestamp": "2024-06-12T18:30:00.000Z",
//       "_id": "666aca2a70aa9bb1d8af33c1"
//     }
//   ],
//   "quick_replies": [],
//   "createdAt": "2024-06-13T07:50:55.745Z",
//   "updatedAt": "2024-06-20T12:26:54.131Z",
//   "__v": 0,
//   "profile": "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",
//   "uuid": "c8efe033-2a83-4da2-9c11-c4880523cb3b",
//   "_chatWindowUser": "6673dc282df26cbf084a1e01",
//   "agency": {
//     "name": "root agency",
//     "meta": {
//       "domains": [],
//       "logo": "https://admin-shopifybot.relinns.website/assets/images/logo-v2.png",
//       "brand": "ShopifyBot",
//       "websiteUrl": "",
//       "_id": "614c81464774d71b1fad621e"
//     },
//     "type": "REGULAR"
//   },
//   "email": "gimoma3256@gmail.com"
// };

let environment = sessionStorage.getItem(`ShopifyBot-${window.parent?.ShopifyBotData?._id}`);


// console.log('environment', environment);

if (environment) {
  try {
    // console.log('indidsre');
    environment = JSON.parse(environment).environment || originalEnvironment;
  } catch (e) {
    environment = originalEnvironment;
  }

  // console.log('outside', environment);
}

const environmentReducer = (state = environment || {
  _id: window.parent.ShopifyBotData._id,
  _user: window.parent.ShopifyBotData._user,
  activeQuestion: null,
  activeFlow: window.parent.ShopifyBotData.flows[0].id,
  preview: window.parent.ShopifyBotData.preview || false,
  embedded: window.parent.ShopifyBotData.embedded || false,
  refresh: true,
  typing: false,
  pause: false,
  activeQuestionType: 'statement',
  skip: false,
  back: false,
  dateTime: false,
  uuid: window.parent.ShopifyBotData.uuid,
  lastQuestion: '',
  profile: window.parent.ShopifyBotData.profile || '',
  plan: window.parent.ShopifyBotData.plan || '',
  liveChat: false,
  isLanding: window.parent.ShopifyBotData.isLanding,
  whitelabel: window.parent.ShopifyBotData.whitelabel || {},
  chatRequestAccepted: false,
  chatRequestRejected: false,
  _chatWindowUser: window.parent.ShopifyBotData._chatWindowUser,
  agentId: undefined,
  socketDisconnected: false,
  installations: window.parent.ShopifyBotData.installations || [],
  agencyData: window.parent.ShopifyBotData.agency || {},
  chatMenu: window.parent.ShopifyBotData.configuration.chatMenu,
  _flow: window.parent.ShopifyBotData.flows[0]._id,
  customAttributesList: []
}, action) => {
  switch (action.type) {
    case UPDATE_ENVIRONMENT: {
      return { ...state, ...action.payload };
    }
    default: {
      return state;
    }
  }
};

export { environmentReducer };
